export default {
    type: 'core',
    init: function (GG) {
        this.plugin.call(GG);
        GG.log('Responsive plugin loaded.');
    },
    plugin: function () {
        var app = this;
        var viewport = document.createElement('meta'), setViewport;
        document.head.appendChild(viewport);
        (setViewport = function () {
            function setAttributes(el, attrs) {
                for (var key in attrs) {
                    el.setAttribute(key, attrs[key]);
                }
            }
            var windowWidth = app.isMobile ? window.screen.availWidth : window.innerWidth, windowHeight = app.isMobile ? window.screen.availHeight : window.innerHeight;
            if (Math.abs(window.orientation / 90) === 1) {
                if (windowWidth < windowHeight) {
                    var tempWidth = windowWidth;
                    windowWidth = windowHeight;
                    windowHeight = tempWidth;
                }
            }
            if (windowWidth < 767) {
                var width = 0;
                app.config.responsive = {};
                document.documentElement.classList.add('gg-responsive');
                if (windowWidth > windowHeight) {
                    app.config.responsive.landscape = true;
                    document.documentElement.classList.add('gg-responsive-landscape');
                    document.documentElement.classList.remove('gg-responsive-portrait');
                }
                else {
                    app.config.responsive.portrait = true;
                    document.documentElement.classList.add('gg-responsive-portrait');
                    document.documentElement.classList.remove('gg-responsive-landscape');
                }
                if (windowWidth > 400) {
                    document.documentElement.classList.add('gg-width-md');
                    document.documentElement.classList.remove('gg-width-lg');
                    document.documentElement.classList.remove('gg-width-sm');
                    app.config.widthType = 'md';
                    width = 500;
                }
                else {
                    document.documentElement.classList.add('gg-width-sm');
                    document.documentElement.classList.remove('gg-width-lg');
                    document.documentElement.classList.remove('gg-width-md');
                    app.config.widthType = 'sm';
                    width = 320;
                }
                setAttributes(viewport, {
                    name: 'viewport',
                    content: 'width=' + width + ', user-scalable=no'
                });
            }
            else {
                delete app.config.responsive;
                app.config.widthType = 'lg';
                document.documentElement.classList.add('gg-width-lg');
                document.documentElement.classList.remove('gg-width-md');
                document.documentElement.classList.remove('gg-width-sm');
                document.documentElement.classList.remove('gg-responsive');
                document.documentElement.classList.remove('gg-responsive-portrait');
                document.documentElement.classList.remove('gg-responsive-landscape');
                setAttributes(viewport, {
                    name: 'viewport',
                    content: "width=" + (app.config.responsiveLgWidth || '1220')
                });
            }
        })();
        window.addEventListener('resize', setViewport);
        window.addEventListener('orientationchange', setViewport);
    }
};
